import { ReactNode } from 'react';
import { Button, Icon } from 'semantic-ui-react';
import {
  BlockHeaderActionGroup,
  BlockHeaderChildren,
  BlockHeaderContainer,
  BlockOverviewHeader,
  HeaderWrapper,
  SearchModeToggleSlot,
} from './BlocksHeader.styles';

export function BlocksHeader({
  showList,
  useAsPicker,
  onCreateBlock,
  onToogleList: onToggleList,
  searchModeToggle,
  children,
}: {
  showList: boolean;
  useAsPicker: boolean | undefined;
  onCreateBlock: () => void;
  onToogleList: () => void;
  /** Rendered next to the Create block button */
  searchModeToggle?: ReactNode;
  children?: any | null;
}) {
  return (
    <HeaderWrapper>
      <BlockHeaderContainer>
        <BlockHeaderActionGroup>
          {!useAsPicker && (
            <>
              <BlockOverviewHeader as="h1">Blocks</BlockOverviewHeader>
              <Button color="green" size="medium" onClick={onCreateBlock}>
                Create block
              </Button>
            </>
          )}
          {searchModeToggle && <SearchModeToggleSlot $first={useAsPicker}>{searchModeToggle}</SearchModeToggleSlot>}
        </BlockHeaderActionGroup>
        <BlockHeaderActionGroup>
          <Button icon active={!showList} onClick={onToggleList}>
            <Icon name="th" />
          </Button>
          <Button icon active={showList} onClick={onToggleList}>
            <Icon name="list" />
          </Button>
        </BlockHeaderActionGroup>
      </BlockHeaderContainer>
      <BlockHeaderChildren>{children}</BlockHeaderChildren>
    </HeaderWrapper>
  );
}
